import { render } from "./DownloadCommissionPayment.vue?vue&type=template&id=15182ed9"
import script from "./DownloadCommissionPayment.vue?vue&type=script&lang=js"
export * from "./DownloadCommissionPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__